import * as React from "react";
import { Link, useParams } from "react-router-dom";
import { axiosInstance, axiosWithoutAuth } from "../../axios/axiosInstance";
import { FORGORPASSWORD } from "../../constants";
import { useNoteAlert } from "../../Context/pleaseNote";

export const ForgotUsernameMain = () => {
  const [txtEmaiAddress, settxtEmaiAddress] = React.useState("");
  const { showNoteAlert } = useNoteAlert();

  const validateEmail = () => {
    var valEmail = document.getElementById("txtEmail").value;
    // var valEmail = document.getElementById("txtEmail").value;
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(valEmail)) {
      showNoteAlert(FORGORPASSWORD.INVALIDMAIL);
      return false;
    }
    // return true;

    //const mailFormat = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    ////var mailFormat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    //if (!valEmail.match(mailFormat)) {
    //    showNoteAlert(FORGORPASSWORD.INVALIDMAIL);
    //    return false;
    //}
  };
  const SubmitClick = () => {
    //  document.getElementById("btnSubmit").disabled = true;
    var data = {
      txtUserMail: txtEmaiAddress,
    };
    if (txtEmaiAddress == "") {
      showNoteAlert(FORGORPASSWORD.EMPTYMAIL);
      var focusID = document.getElementById("txtEmail");
      focusID.focus();
      return false;
    } else {
      var ValidateEmail = validateEmail();
      if (ValidateEmail == false) {
        var focusID = document.getElementById("txtEmail");
        focusID.focus();
        return false;
      }
    }
    axiosInstance
      .post("ForgotUserName/ForgotUserNameSubmit", data)
      .then((response) => {
        if (response.data != "") {
          //document.getElementById("btnSubmit").disabled = false;
          if (response.data != "sucess") {
            // document.getElementById("lblError").style.display = "block";
            showNoteAlert(response.data);
            // document.getElementById("divShowDetails").style.display = "none";
          } else {
            document.getElementById("divUpdateSuccess").style.display = "block";
            document.getElementById("divShowDetails").style.display = "none";
            document.getElementById("btnSubmit").style.display = "none";
            // document.getElementById("lblError").style.display = "none";
          }
          //setlbltotal(response.data.NetAmount);
          //setlbltax(response.data.TaxAmount);
          //setlblsubtotal(response.data.GrossAmount);
        } else {
          document.getElementById("btnSubmit").disabled = false;
        }
      })
      .catch((error) => console.log(error.message));
  };

  return (
    <div className="loginWrapper-verification">
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-lg-6 offset-md-2 offset-lg-3">
            <label
              id="lblError"
              style={{ fontSize: "14px", color: "red", display: "none" }}
            />
          </div>
        </div>
      </div>
      <div
        className="container"
        id="divShowDetails"
        style={{ display: "block" }}
      >
        <div className="row">
          <div className="col-md-8 col-lg-6 offset-md-2 offset-lg-3">
            <div className="loginVerification-wrapper text-center">
              <div className="loginVerification-wrapperTitle">
                <h1 className="fw-semibold">Forgot Username</h1>
                <p className="fs-14 fw-normal">
                  Enter your registered email to receive your username
                </p>
              </div>
              <form>
                <div className="row mt-4">
                  <div className="col-md-12">
                    <div className="floating-input floatingEmail-input mb-3">
                      <input
                        id="txtEmail"
                        className="form-control form-input"
                        type="email"
                        placeholder=""
                        required=""
                        value={txtEmaiAddress}
                        onChange={(changeEvent) =>
                          settxtEmaiAddress(changeEvent.target.value)
                        }
                      />
                      <label for="emailid">Email</label>
                    </div>
                  </div>
                  <div className="col-md-12 loginVerification-btn">
                    <div className="button-effect">
                      <a
                        className="btn btn-products btn-addcart"
                        data-bs-dismiss="modal"
                        onClick={() => SubmitClick()}
                      >
                        {" "}
                        Send Username
                      </a>
                    </div>
                    <p className="mt-4">
                      Back to{" "}
                      <Link to="/Login" className="text-decoration-underline">
                        Login Screen
                      </Link>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container"
        id="divUpdateSuccess"
        style={{ display: "none" }}
      >
        <div className="row">
          <div className="col-md-6 offset-md-3">
            <div className="loginVerification-wrapper text-center">
              <div className="loginVerification-wrapperTitle">
                <svg
                  width="100"
                  height="101"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="loginVerificationImg"
                >
                  <rect
                    x="2"
                    y="2.5"
                    width="96"
                    height="96"
                    rx="48"
                    fill="white"
                  />
                  <rect
                    x="2"
                    y="2.5"
                    width="96"
                    height="96"
                    rx="48"
                    stroke="#3BA429"
                    strokeWidth="4"
                    className="drawRect"
                  />
                  <path
                    d="M62.5 71.75H37.5C30 71.75 25 68 25 59.25V41.75C25 33 30 29.25 37.5 29.25H62.5C70 29.25 75 33 75 41.75V59.25C75 68 70 71.75 62.5 71.75Z"
                    stroke="#3BA429"
                    strokeWidth="3.75"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="drawPath"
                  />
                  <path
                    d="M62.5 43L54.675 49.25C52.1 51.3 47.875 51.3 45.3 49.25L37.5 43"
                    stroke="#3BA429"
                    strokeWidth="3.75"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="drawPath"
                  />
                </svg>

                {/*<img src="https://cdn.wes.com.au/wesreact/newui/img/email_img/SendMailSuccess.gif" alt="Facebook" width="100" height="101" />*/}
                {/*<svg*/}
                {/*    className="loginVerificationImg"*/}
                {/*    width="100"*/}
                {/*    height="101"*/}
                {/*    viewBox="0 0 100 101"*/}
                {/*    fill="none"*/}
                {/*    xmlns="http://www.w3.org/2000/svg"*/}
                {/*>*/}
                {/*    <rect x="2" y="2.5" width="96" height="96" rx="48" fill="white" />*/}
                {/*    <rect*/}
                {/*        x="2"*/}
                {/*        y="2.5"*/}
                {/*        width="96"*/}
                {/*        height="96"*/}
                {/*        rx="48"*/}
                {/*        stroke="#3BA429"*/}
                {/*        strokeWidth="4"*/}
                {/*    />*/}
                {/*    <path*/}
                {/*        d="M62.5 71.75H37.5C30 71.75 25 68 25 59.25V41.75C25 33 30 29.25 37.5 29.25H62.5C70 29.25 75 33 75 41.75V59.25C75 68 70 71.75 62.5 71.75Z"*/}
                {/*        stroke="#3BA429"*/}
                {/*        strokeWidth="3.75"*/}
                {/*        strokeMiterlimit="10"*/}
                {/*        strokeLinecap="round"*/}
                {/*        strokeLinejoin="round"*/}
                {/*    />*/}
                {/*    <path*/}
                {/*        d="M62.5 43L54.675 49.25C52.1 51.3 47.875 51.3 45.3 49.25L37.5 43"*/}
                {/*        stroke="#3BA429"*/}
                {/*        strokeWidth="3.75"*/}
                {/*        strokeMiterlimit="10"*/}
                {/*        strokeLinecap="round"*/}
                {/*        strokeLinejoin="round"*/}
                {/*    />*/}
                {/*</svg>*/}
                <h1 className="fw-semibold mt-4">Email Sent Successfully!</h1>
                <p className="fs-14 fw-normal">
                  If an account with this email address exists, you will receive
                  an email from us shortly.
                </p>
                <div className="loginVerification-btn">
                  <p className="mt-4">
                    Back to{" "}
                    <Link to="/Login" className="text-decoration-underline">
                      Login Screen
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
